module.exports = __webpack_public_path__ + "static/media/IMG_4095 - Version 2.08228850.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/new/IMG_4095 - Version 2.JPG
// module id = 187
// module chunks = 0